/**
 * Thousand Scripts
 *
 * This javascript file holds the custom code Thousand Helment
 * runs on the store.
 *
 * TODO: Refactor custom code from each template and move it here
 * if possible.
 *
 */


//TODO: fix missing Shopify global
var Shopify = Shopify || {};
Shopify.formatMoney = Shopify.formatMoney || function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)};

var formatMoneyStripTrailingZeros = function (cents, format) {
  if(!format){
  format = $('body').data('money-format');
}
  return Shopify.formatMoney(cents, format).replace('.00', '');
}

 // Register namespace
 window.thousand = window.thousand || {};

// Generate a private scope through this wrapper
(function () {

// Sub-namespaces
thousand.utils       = thousand.utils || {};
thousand.controllers = thousand.controllers || {};
thousand.callbacks   = thousand.callbacks || {};
thousand.helpers     = thousand.helpers || {};
thousand.assets      = thousand.assets || {};


var DEBUG = true;

// Logging function for this module. Enabled if DEBUG is enabled.
var log = DEBUG ? console.log.bind(console, '[Thousand]') : function () {};

/**
 * Extend jQuery easings
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
$.extend($.easing, {
    easeOutQuad: function (x, t, b, c, d) {
        return -c *(t/=d)*(t-2) + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    }
});




// -----------------------------------------
// ------------- Utilities -----------------
// -----------------------------------------


/**
 * Select product's variant from a string with format:
 *
 * <option1>:<option2>:<option3>
 *
 * Examples:
 *
 *   var variant = { option1: 'Navy', option2: 'Small', option3: 'Premium' };
 *   thousand.utils.variantAsString(variant);
 *
 * Will return 'Navy:Small:Premium'
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.variantAsString = function (variant) {
  return [
      thousand.utils.handlify(variant.option1 || ''),
      thousand.utils.handlify(variant.option2 || ''),
      thousand.utils.handlify(variant.option3 || '')
    ].join(':')
     .replace(/(:|:[\s:]+)$/, '');
}


/**
 * Select product's variant from a string with format:
 *
 * <option1>:<option2>:<option3>
 *
 * Examples:
 *
 *   thousand.utils.variantFromName(product, 'Navy:Small');
 *   thousand.utils.variantFromName(product, 'Navy');
 *   thousand.utils.variantFromName(product, 'Navy::');
 *   thousand.utils.variantFromName(product, ':Small:');
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.variantFromName = function (product, string) {
  var options = string.split(':');

  function sanitize(v) {
    return v == "" ? undefined : v;
  };

  options = options.map(sanitize);

  var query = {};

  if (options[0]) {
    query.option1 = function (value) {
      return thousand.utils.handlify(value) == options[0];
    }
  }

  if (options[1]) {
    query.option2 = function (value) {
      return thousand.utils.handlify(value) == options[1];
    }
  }

  if (options[2]) {
    query.option2 = function (value) {
      return thousand.utils.handlify(value) == options[2];
    }
  }

  return thousand.utils.queryVariants(product, query, true);
}


/**
 * Get the list of variants matching the query. The query is
 * a diccionary of key values. Each key is a variant attribute.
 * The variant that matches every query value on each key will
 * be returned.
 *
 * @param product A shopify product
 *
 * @param query A diccionary with attribute-values used to search
 *              for matching variants. For example:
 *
 *              queryVariants({ option1: "Navy", option2: "Small" })
 *
 *              will return a list of variants with value "Navy" on
 *              option1 and "Small" on option2.
 *
 *              You can also specify functions to perofrm the comparison
 *
 *              queryVariants({ option1 : function (v) { return v == 'Navy' } })
 *
 * @param findOne A boolean that indicates if the function should return
 *                the first found match or the full list.
 *
 * @return A list of variants matching the query.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.queryVariants = function(product, query, findOne) {

  findOne = findOne === true;

  function variantMatchQuery(variant, query) {
    return Object.keys(query).reduce(function (conclusion, attribute) {
      if (typeof query[attribute] == 'function') {
        return conclusion && query[attribute](variant[attribute]);
      } else {
        return conclusion && (query[attribute] === undefined || variant[attribute] == query[attribute]);
      }
    }, true);
  };

  var results = [];

  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variantMatchQuery(variant, query)) {
      results.push(variant);

      if (findOne) {
        break;
      }
    }
  }

  return findOne ? (results[0] ? results[0] : false) : results;
}


/**
 * Execute functions in sequence using the same
 * input arguments every time.
 *
 * @param ...functions
 *
 * @return results
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.sequence = function (/* ...functions */) {
  var functions = Array.prototype.slice.call(arguments);

  return function (/* ...args */) {
    var args = Array.prototype.slice.call(arguments);

    return functions.map(function (f, i) {
      return f.apply(null, args);
    });
  };
}


/**
 * Transform in text into a handle-like string.
 *
 * For example, it will transform "Carbon Black" into "carbon-black".
 *
 * @param text Any string
 * @return handle A lowercase string replacing whitespace with dashes.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.handlify = function (text) {
  text = String(text);

  return text
    ? text.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^0-9a-zA-Z\-\_]+/g, '')
    : ""
  ;
}

// -----------------------------------------
// ------------- Callbacks -----------------
// -----------------------------------------



/**
 *
 * Callback for variant selection called from option_selection.js
 *
 * This callback hooks on Shopify's operation_selection.js
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.callbacks.onVariantSelected = function (variant, selector) {
//   log('Variant Selected event dispatched');
  $(document).trigger('thousand:variant:selected', variant, selector);
};


/**
 * Register all the needed callbacks or hook into some global callback.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.callbacks.init = function() {
//   log('Callbacks initialized');
};




// -----------------------------------------
// ------------- Controllers ---------------
// -----------------------------------------

/**
 * Hash Link Scroll
 *
 * Make all hash links (anchor) with data-scroll attribute to
 * scroll towards their target.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.hashLinkScroll = function (args) {
  var options = {};
  $.extend(options, {
    scrollContainerSelector : 'html, body',
    speed  : 1,
    targetPositionOffset: -40,
    easing: 'easeOutCubic'
  }, args);

  // Retrieve Hash links filtering those that don't actually link to anything
  var $hashLinks = $('a[href*="#"][data-scroll]').not('[href="#"]').not('[href="#0"]')

  // Call for scroll animation
  function performScroll($target, done) {
    var $scrollContainer = $(options.scrollContainerSelector);

    // Calculate duration based on distance
    var distance = Math.abs($target.offset().top - $scrollContainer.offset().top);
     var duration = distance * (1/options.speed);
    var newTopPosition = Math.max(0, $target.offset().top + options.targetPositionOffset);

//     log('Perform hash link scroll');

    return $scrollContainer.animate({ scrollTop: newTopPosition }, {
      duration : duration,
      easing: options.easing,
      complete: done
    });
  };

  // On-page links
  function isOnPageLink(link) {
    return (
      location.pathname.replace(/^\//, '') == link.pathname.replace(/^\//, '')
        &&
      location.hostname == link.hostname
     );
  };

  // Register click handler
  $hashLinks.click(function(event) {

      if (isOnPageLink(this)) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          performScroll($(target), function() {
//             log('Change focus');
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
};

// Alternate scroller
$('body').on('click', '.smooth-scroll-btn', function(e) {
  e.preventDefault();
  $thisHash = $(this.hash);
  $('html, body').animate({
      scrollTop: $thisHash.offset().top
  }, 1000);
});

/**
 * Scroll to element
 *
 * Use data-scroll-to="<selector>" attribute+value to scroll to
 * certain element.
 *
 * For example:
 *
 *    <a href="#" data-scroll-to="#footer">Go to footer</a>
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.scrollTo = function (args) {
  var options = {};
  $.extend(options, {
    selector : '[data-scroll-to]',
    scrollTarget : 'html, body',
    smooth : true,
    speed  : 1,
    targetPositionOffset: 0,
    easing: 'easeOutCubic',
    preventDefault : true,
    stopPropagation: true,

    // Attribute present on trigger to extract the selector used to find the target
    targetSelectorAttribute: 'data-scroll-to',

    // Calculate the selector for the target. Defaults uses
    // targetSelectorAttribute to grab the selector.
    // "this" context is the trigger element.
    targetSelector : function () {
      return $(this).attr(options.targetSelectorAttribute);
    },

    // Callbacks. They will receive the element that triggers the action,
    // this is, an individual element matching the options.selector
    onComplete : function(){},
    onStart    : function(){}
  }, args);


  $(options.selector).click(function (event) {

    var $trigger = $(this);
    var targetSelector = typeof options.targetSelector == 'function' ? options.targetSelector.call(this) : options.targetSelector;
    var $target = $(targetSelector);

    // Calculate duration based on distance
    var distance = Math.abs($target.offset().top - $trigger.offset().top);
     var duration = options.smooth
      ? distance * 2 * (1/options.speed)
      : 1
    ;

//     log('Perform scroll-to', options, duration);

    // Call start callback
     ;

    // Execute animation
    $(options.scrollTarget).stop()
      .animate({
        scrollTop: $target.offset().top + options.targetPositionOffset
      }, {
        duration :duration,
        easing   : options.easing,
        start    : options.onStart.bind(this),
        complete : options.onComplete.bind(this)
      });

    // Evaluate default prevention
    if (options.preventDefault) {
    event.preventDefault();
    }

    // Evaluate propagation stop
    if (options.stopPropagation) {
      event.stopPropagation();
    }
  });

};


/**
 * Toggle Tab and Scroll Controller
 *
 * Use data-toggle-tab-and-scroll attribute to scroll to
 * tab content and enable it.
 *
 * Usage:
 *
 *    <a data-toggle-tab-and-scroll="<tabId>">...</a>
 *
 * Here the data-toggle-tab-and-scroll holds the id of the tab to trigger.
 *
 *
 * For example:
 *
 *    <a href="#" data-toggle-tab-and-scroll="#fitguide">See fit guide</a>
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.toggleTabAndScroll = function () {

  function getTabId() {
    // "this" must reference the trigger element.
    return $(this).attr('data-toggle-tab-and-scroll');
  };

  function isVisible(element) {
    return $(element).css('display') != 'none';
  }

  function isDesktop() {
    return isVisible($('#tabstyle'));
  }

  // Configure generic scrollTo controller
  thousand.controllers.scrollTo({
    selector : '[data-toggle-tab-and-scroll]',
    targetPositionOffset : -40,
    speed: 1,
    targetSelector : function () {
      var tabId = getTabId.call(this);
      var target;

      if (isDesktop()) {
        target = '[data-toggle="tab"][href="' + tabId + '"]';

      } else {
        // Detect the first accordion content opened, or select the actual target
        $('.accordion-toggle').each(function () {
            var $tab = $(this);
            var $content = $tab.next();

            if (target == null && isVisible($content)) {
              target = $tab;
            }
        });
        target = target || $('.accordion-toggle[data-tab-id="' + tabId + '"]');
      }

//       log('Scrolling to', target);

      return target;
    },
    onStart  : function () {
      // TODO: IMPROVE: This would be better to address directly in
      // code instead of triggering click.

      var tabId = getTabId.call(this);

      if (isDesktop()) {
        // Desktop case
        var $tab = $('a[href="' + tabId + '"][data-toggle="tab"]');
        $tab[0].click(); // unwrap
//         log('Show tab', $tab, '(desktop)');

      } else {
        // Mobile case
        var $tab = $('.accordion-toggle[data-tab-id="' + tabId + '"]');
        var $tabContent = $($tab.next());

        if (!isVisible($tabContent)) {
          $tab.get(0).click()
        }

//         log('Show tab', $tab, '(mobile)');

      }

    }
  });
};


/**
 * Handle "scrollTopButton", previously #myBtn
 *
 * @author Unknown, refactored by Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.scrollTopButton = function () {
  // When the user scrolls down ?px from the top of the document, show the button
  // When the user clicks on the button, scroll to the top of the document

  function shouldDisplayButton() {
    var bodyScrollTop = document.body.scrollTop;
    var documentScrollTop = document.documentElement.scrollTop;
    return bodyScrollTop > 1600 || documentScrollTop > 1600;
  }

  function scroll() {
    $('#scrollTopButton').css('display', shouldDisplayButton() ? 'block' : 'none');
  }

  function goToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  $('#scrollTopButton').on('click', goToTop);

  $(window).on('scroll', scroll);
}


/**
 * Handle swatch tile click
 *
 * @author Unknown, refactored by Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.swatchTile = function () {
  $(".swatch-tile").click(function(e){
    e.preventDefault();
    var target = $(this).data("target-select");
    $(target).val($(this).data('value')).change();

    var selectedNow = $(this).parent().find(".swatch-tile");
    selectedNow.removeClass('active');
    $(this).addClass('active');
  });
};


/**
 * Controllers initialization
 *
 * Call functions which will setup controllers
 * to DOM elements (tipically). For example, you
 * can select certain DOM based on a data-attribute
 * and apply a behavior to all those selected.
 *
 * For example, jQuery Match Height plugin uses
 * this pattern: https://github.com/liabru/jquery-match-height
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.init = function () {
  // Refactored, inherited code
  thousand.controllers.swatchTile();
  thousand.controllers.scrollTopButton();

  // New code
  thousand.controllers.toggleTabAndScroll();
  thousand.controllers.hashLinkScroll();
};




// -----------------------------------------
// .....--------- Helpers  -----------------
// -----------------------------------------


thousand.helpers.Thousand180VariantImages = function (variantImageUrls, defaultColor, showImageHandler) {
  showImageHandler = showImageHandler || function () {};
  defaultColor = defaultColor || Object.keys(variantImageUrls)[0];

  var variantImagesCache = {};
  var variantImages = [];
  var currentVariantImageId = 3;
  var variantImageLastChange = null;

  var self = {};

  self.setVariant = function (color) {
    // Initialize cache
    if (!variantImagesCache[color]) {
      // Get variant images or find some others to show.
      var imageUrls = variantImageUrls[color] || variantImageUrls[defaultColor];

      // Create images from urls
      variantImagesCache[color] = imageUrls.map(function (url, i) {
        var image = new Image(265, 406);
        image.src = url;
        return image;
      });
    }

    variantImages = variantImagesCache[color];
    self.showImage(currentVariantImageId);
  };

  self.getImage = function (i) {
    // Obtain the image at "i" position, or retrieve the last one.
    return variantImages[i] || variantImages[variantImages.length - 1];
  }

  self.getImageUrl = function (i) {
    return self.getImage(i).src;
  }

  self.showImage = function (i) {
    var url = self.getImageUrl(i);
    showImageHandler(url, i);
    currentVariantImageId = i;
    variantImageLastChange = Date.now();
    return variantImageLastChange;
  }

  // Add a timeout to verify if some other image
  // was chosen. Avoids flickering.
  self.showImageWithDelay = function (i) {
    var _lastChange = variantImageLastChange;
    setTimeout(function () {
      VariantImages.showImage(i);
      // If no other change was requested, show original
      if (_lastChange == variantImageLastChange) {
        VariantImages.showImage(3);
      }
    }, 50);
  }

  $(document).on('thousand:variant:selected', function (event, variant) {
    var color = thousand.utils.handlify(variant.option1);
    self.setVariant(color);
  });

  return self;
}


thousand.helpers.Thousand180VariantImagesSetup = function (initialVariant) {
  var VariantImages = new thousand.helpers.Thousand180VariantImages(
    thousand.assets.helmets.view180Images,
    initialVariant,
    function (url, i) {
      $('.img-180')[0].src = url;
    }
  );
  VariantImages.setVariant(initialVariant);
  return VariantImages;
}


thousand.helpers.Thousand180VariantImagesMobileSetup = function (initialVariant) {
  var VariantImages = new thousand.helpers.Thousand180VariantImages(
    thousand.assets.helmets.view180ImagesMobile,
    initialVariant,
    function (url, i) {
      $('#sliderStatus').html(i);
      $("#img").prop("src", url);
    }
  );

  VariantImages.setVariant(initialVariant);

  $(document).on('input change', '#slider', function() {//listen to slider changes
      var v=$(this).val();//getting slider val
     VariantImages.showImage(parseInt(v) - 1)
  });

  return VariantImages
}






// -----------------------------------------
// --------- Shopify Customization ---------
// -----------------------------------------


/**
 * The following code customizes different methods from option_selection.js
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */


// Overrides selectVariantFromParams to provide 'variant_name' query parameter
// parsing.
if(Shopify && Shopify.OptionSelectors){
  Shopify.OptionSelectors.prototype.selectVariantFromParams = function (options) {
    var variantId = Shopify.urlParam("variant");
    var variantName = Shopify.urlParam("variant_name");

    if (variantName) {
      var variant = thousand.utils.variantFromName(this.product, variantName);
      if (variant) {
        variantId = variant.id;
      }
    }

//     log('Customize shopify', variantId, variantName);
    return this.selectVariant(variantId, options);
  };


  // TODO: Remove, used as checkpoint for debugging
  var _selectVariant = Shopify.OptionSelectors.prototype.selectVariant;
  Shopify.OptionSelectors.prototype.selectVariant = function (variantId, options) {
//     log('Select variant', variantId);
    return _selectVariant.call(this, variantId, options);
  };


  // Modify initDropdown behavior in a way it will try to parse
  // query parameters before using the first element in the dropdown
  // to initialize the variant selector.
  Shopify.OptionSelectors.prototype.initDropdown = function () {
    var options = { initialLoad: true };
    var self = this;
    setTimeout(function () {
      if (!self.selectVariantFromParams(options)) {
        var successDropdownSelection = self.selectVariantFromDropdown(options);
        if (!successDropdownSelection) {
          self.fireOnChangeForFirstDropdown.call(self, options);
        }
      }
    });
  };


  // Override variant change handler on Shopify.OperationSelectors to
  // write the variant name into the url instead of the ID.
  Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (variant, selector, data) {
    if (this.browserSupports()) {
      if (variant && !data.initialLoad && !data.popStateCall) {
        var variantName = thousand.utils.variantAsString(variant);
        history.replaceState({}, document.title, '?variant_name=' + variantName);
      }
    }
    thousand.callbacks.onVariantSelected(variant);
  };
}


// -----------------------------------------
// ----------- Assets    -------------------
// -----------------------------------------

thousand.assets.helmets = {
  view180ImagesMobile : {
    'carbon-black' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-7-fs-m.jpg?v=3968'
    ],
    'thousand-navy' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-7-fs-m.jpg?v=3968'
    ],
    'willowbrook-mint' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-1-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-2-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-3-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-4-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-5-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-6-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-7-m.jpg?v=3968'
    ],
    'speedway-creme' : [
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-1-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-2-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-3-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-4-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-5-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-6-m.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-7-m.png?v=3968'
    ],
    'stealth-black' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-7-fs-m.jpg?v=3968'
    ],
    'arctic-grey' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-7-fs-m.jpg?v=3968'
    ],    
    'stay-gold' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-7-fs-m.jpg?v=3968'
    ],
    'daybreak-red' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-7-fs-m.jpg?v=3968'
    ],
    'gt-stripe' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-1-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-2-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-3-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-4-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-5-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-6-fs-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-7-fs-m.jpg?v=3968'
    ],
    'color-blocks' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-1-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-2-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-3-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-4-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-5-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-6-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-7-m.jpg?v=3968'
    ],
    'coral-reef' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-1-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-2-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-3-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-4-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-5-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-6-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-7-m.jpg?v=3968'
    ],
    'memphis-movement' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-1-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-2-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-3-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-4-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-5-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-6-m.jpg?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-7-m.jpg?v=3968'
    ],
    'polished-titanium' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-1-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-2-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-3-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-4-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-5-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-6-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-7-fs-m.png?v=3968'
    ],
    'rose-gold' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-1-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-2-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-3-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-4-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-5-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-6-fs-m.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-rose-gold-7-fs-m.png?v=3968'
    ]
  },

  view180Images: {
    'speedway-creme' : [
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-1.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-2.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-3.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-4.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-5.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-6.png?v=3968',
        '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-7.png?v=3968'
    ],
    'willowbrook-mint' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-1.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-2.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-3.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-4.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-5.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-6.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-7.png?v=3968'
    ],
    'carbon-black' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-carbon-black-7-fs.png?v=3968'
    ],
    'thousand-navy' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-navy-7-fs.png?v=3968'
    ],
    'stealth-black' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stealth-black-7-fs.png?v=3968'
    ],    
    'arctic-grey' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-arctic-grey-7-fs.png?v=3968'
    ],    
    'stay-gold' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-1.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-2.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-3.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-4.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-5.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-6.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-7.png?v=3968'
    ],
    'daybreak-red' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-daybreak-red-7-fs.png?v=3968'
    ],
    'gt-stripe' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-gt-stripe-7-fs.png?v=3968'
    ],
    'color-blocks' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-1.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-2.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-3.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-4.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-5.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-6.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-7.png?v=3968'
    ],
    'coral-reef' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-1.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-2.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-3.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-4.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-5.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-6.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-7.png?v=3968'
    ],
    'memphis-movement' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-1.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-2.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-3.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-4.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-5.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-6.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-7.png?v=3968'
    ],
    'rose-gold' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-7-fs.png?v=3968'
    ],
    'polished-titanium' : [
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-1-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-2-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-3-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-4-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-5-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-6-fs.png?v=3968',
      '//www.explorethousand-wholesale.com/cdn/shop/files/thousand-helmet-180-polished-titanium-7-fs.png?v=3968'
    ]
  }
}




// -----------------------------------------
// ---------------- Main -------------------
// -----------------------------------------


/**
 * Execute scripts without waiting for events.
 * Commands here will execute when the file is
 * evaluated.
 **/
thousand.start = function () {
  thousand.callbacks.init();
};


/**
 * Handle document load
 **/
thousand.load = function () {
  $(".banner-section").each(function(i,e){
    $(e).find(".copy-text").fadeIn();
  });

//   log('Scripts loaded');
};


/**
 * Handle document ready.
 * Initialize Thousand Helmet scripts.
 **/
thousand.init = function () {
  thousand.controllers.init();
};


    // Call scripts
    $(document).ready(thousand.init.bind(thousand));
    $(window).on('load', thousand.load.bind(thousand));
    thousand.start();

    }());
    //Removing products based on user location
    if(user_loc=='eu'){
      jQuery('div [data-warehouse-usa]').remove();
    }else{
      jQuery('div [data-warehouse-eu]').remove();
    }

    if(jQuery('.shopify-section .product-list').length){
      jQuery('.shopify-section .product-list').each(function(i,v){
        if(jQuery(this).find('div').length === 0){
            jQuery(this).parents('.shopify-section').remove();
        }
      })
    }
   
	if(restrict_products.length){
      $.each(restrict_products,function(i,v){
        pids[v.p] = pids[v.p] - v.q;
      });
    }
	
	$(document).ready(function(){
  
      var floating_popup = jQuery('.floating_background').css('display');
      if( typeof floating_popup != 'undefined' && floating_popup == 'block' ) {
          $('body').addClass('login-popup-visible');
      }

      var variants = typeof(meta.product) != 'undefined' ? meta.product.variants : {};
      var citems = window.BOLD.common.Shopify.cart.items;
      var checkout = $('form#cart_form').find('#checkout');

      var total_variations = {};

      $.each(citems, function (k,v) {
        total_variations[v.product_id] = typeof(total_variations[v.product_id]) != 'undefined' ?  parseInt(total_variations[v.product_id]) + parseInt(v.quantity) : v.quantity;
      });

      if (window.location.pathname.indexOf('/cart') !== -1){
          proCartRestrict(pids,citems,total_variations,checkout);
      }

      if (window.location.pathname.indexOf('/products/') !== -1){
          proDetailRestrict(pids,citems,total_variations);
          $('.add_to_cart').click(function(){
             $( document ).ajaxComplete(function( event, xhr, settings ) {
                if(settings.url.indexOf("/cart.js") != -1){
                  citems = xhr.responseJSON.items;
                  total_variations = {};
                  $.each(citems, function (k,v) {
                    total_variations[v.product_id] = typeof(total_variations[v.product_id]) != 'undefined' ?  parseInt(total_variations[v.product_id]) + parseInt(v.quantity) : v.quantity;
                  });
                }
             });
          });
      }


      $('.add_to_cart').click(function(){
          $( document ).ajaxComplete(function( event, xhr, settings ) {
              if(settings.url.indexOf("/cart.js?_=") != -1){
                  citems = xhr.responseJSON.items;
                  total_variations = {};
                  $.each(citems, function (k,v) {
                      total_variations[v.product_id] = typeof(total_variations[v.product_id]) != 'undefined' ?  parseInt(total_variations[v.product_id]) + parseInt(v.quantity) : v.quantity;
                  });
                  $.each(pids, function(p,k) {
                    var limit = k;
                    $(".msg_"+p).remove();
                    $('#product_form_'+p).parents('.product-copy-section').find('.product_name').after('<div class="option_title msg_'+p+'" style=" color: red; font-weight: bold;"><span class="swatch-type">Limit '+limit+' items</span>'+(typeof(total_variations[p])!="undefined"?'<span class="swatch-seperator"> -</span><span class="size_chart">You have '+total_variations[p]+' in cart</span>':'')+'</div>');

                    if($('form.shopify-product-form').attr('id') == 'product_form_'+p ){

                      var atc = $('form.shopify-product-form').find('.add_to_cart');
                      var pr_limit = typeof(total_variations[p]) != 'undefined' ? parseInt(limit) - parseInt(total_variations[p]) : limit ;

                      if(pr_limit<=0){
                        atc.prop('disabled', true);
                        atc.css('cursor', 'not-allowed');
                        setTimeout(function(){
                          $("#warn_"+p).remove();
                          atc.find('.text').text('Limit Exceeded');
                          $('form.shopify-product-form').find('input#quantity').parent('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
                        }, 500);
                      }else{
                        $('#warn_'+p).remove();
                        atc.find('.text').text('Add to Cart');
                        atc.prop('disabled', false); 
                        atc.css('cursor', 'auto');
                      }

                      $('form.shopify-product-form').find('input#quantity').on('change',function(){

                        if($(this).val() > pr_limit){
                          $('#warn_'+p).remove();
                          $(this).parent('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
                          atc.find('.text').text('Limit Exceeded');
                          atc.prop('disabled', true);
                          atc.css('cursor', 'not-allowed');
                        }else{
                          $('#warn_'+p).remove();
                          atc.find('.text').text('Add to Cart');
                          atc.prop('disabled', false); 
                          atc.css('cursor', 'auto');
                        }
                    });

                    Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (variant, selector, data) {
                        if (this.browserSupports()) {
                          if (variant && !data.initialLoad && !data.popStateCall) {
                            $(document).trigger('thousand:variant:selected', variant, selector);
                            var current_qua=$('input#quantity').val();
                            if(current_qua > pr_limit){
                              $('#warn_'+p).remove();
                              $('.qty-input').parent('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
                              atc.find('.text').text('Limit Exceeded');
                              atc.prop('disabled', true);
                              atc.css('cursor', 'not-allowed');
                            }else{
                              $('#warn_'+p).remove();
                              atc.find('.text').text('Add to Cart');
                              atc.prop('disabled', false); 
                              atc.css('cursor', 'auto');
                            }
                            $('input#quantity').val(1);
                          }
                        }
                      };
                    }
                  });
                  $(event.currentTarget).unbind('ajaxComplete');
                  $('input#quantity').val(1);
                  }
              });
          });    
  	});
  

    function proDetailRestrict(pids,citems,total_variations){
        var interval = setInterval(function(){

        jQuery.getJSON('/cart.js', function(cart) {
          citems = cart.items;
          total_variations = {};
          $.each(citems, function (k,v) {
            total_variations[v.product_id] = typeof(total_variations[v.product_id]) != 'undefined' ?  parseInt(total_variations[v.product_id]) + parseInt(v.quantity) : v.quantity;
          });
        });

        $.each(pids, function(p,k) {
         var limit = k;
          $(".msg_"+p).remove();
          $('#product_form_'+p).parents('.product-copy-section').find('.product_name').after('<div class="option_title msg_'+p+'" style=" color: red; font-weight: bold;"><span class="swatch-type">Limit '+limit+' items</span>'+(typeof(total_variations[p])!="undefined"?'<span class="swatch-seperator"> -</span><span class="size_chart">You have '+total_variations[p]+' in cart</span>':'')+'</br><a href="mailto:wholesale@explorethousand-wholesale.com" style="color:#202c46;text-decoration:underline;">Have any questions?</a></div>');

          if($('form.shopify-product-form').attr('id') == 'product_form_'+p ){

            var atc = $('form.shopify-product-form').find('.add_to_cart');
            var pr_limit = typeof(total_variations[p]) != 'undefined' ? parseInt(limit) - parseInt(total_variations[p]) : limit ;

            if(pr_limit<=0){
              atc.prop('disabled', true);
              atc.css('cursor', 'not-allowed');
              setTimeout(function(){
                $("#warn_"+p).remove();
                atc.find('.text').text('Limit Exceeded');
                $('form.shopify-product-form').find('input#quantity').parent('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
              }, 500);
            }else{
              $('#warn_'+p).remove();
              atc.find('.text').text('Add to Cart');
              atc.prop('disabled', false); 
              atc.css('cursor', 'auto');
            }

            $('form.shopify-product-form').find('input#quantity').on('change',function(){
                clearInterval(interval);
                if(parseInt($(this).val()) > parseInt(pr_limit)){
                  $('#warn_'+p).remove();
                  $(this).parent('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
                  atc.find('.text').text('Limit Exceeded');
                  atc.prop('disabled', true);
                  atc.css('cursor', 'not-allowed');
                }else{
                  $('#warn_'+p).remove();
                  atc.find('.text').text('Add to Cart');
                  atc.prop('disabled', false); 
                  atc.css('cursor', 'auto');
                }
            });
            Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (variant, selector, data) {
              if (this.browserSupports()) {
                if (variant && !data.initialLoad && !data.popStateCall) {
                        $(document).trigger('thousand:variant:selected', variant, selector);
                  var current_qua=$('input#quantity').val();
                  if(parseInt(current_qua) > parseInt(pr_limit)){
                    $('#warn_'+p).remove();
                    $('.qty-input').after('<p id="warn_'+p+'">Maximum quantity is '+limit+'</p>');
                    atc.find('.text').text('Limit Exceeded');
                    atc.prop('disabled', true);
                    atc.css('cursor', 'not-allowed');
                  }else{
                    $('#warn_'+p).remove();
                    atc.find('.text').text('Add to Cart');
                    atc.prop('disabled', false); 
                    atc.css('cursor', 'auto');
                  }
                  $('input#quantity').val(1);
                }
              }
            };
          }
        });
      }, 1000);
    }

	
 
    function proCartRestrict(pids,citems,total_variations,checkout,limit){
      $.each(pids, function(p,k) {
        var limit = k;
          $.each(citems, function (k,v) {
            if(v.product_id == p && v.quantity > limit){
              if($('#warn_'+v.id).length == 0){
                $('#updates_'+v.id).parent('.product-quantity-box').after("<p id='warn_"+v.id+"'>You've exceeded the limit allowed for the "+v.product_title+"</p>");
              }
              checkout.prop('disabled', true);
              checkout.css('cursor', 'not-allowed');
              checkout.html('<span class="icon-lock"></span>Limit Exceeded');
            }
            if(v.product_id == p && total_variations[p] > limit){
              if($('#warn_'+v.id).length == 0){
                $('#updates_'+v.id).parent('.product-quantity-box').after("<p id='warn_"+v.id+"'>You've exceeded the limit allowed for the "+v.product_title+"</p>");
              }
              checkout.prop('disabled', true);
              checkout.css('cursor', 'not-allowed');
              checkout.html('<span class="icon-lock"></span>Limit Exceeded');
            }
            if(v.product_id == p && (v.quantity > limit || total_variations[p] > limit || v.quantity == limit || total_variations[p] == limit) ){
              $('#updates_'+v.id).parent('.product-quantity-box').find('.product-plus').remove();
              $('#updates_'+v.id).prop('disabled',true);
            }
            if(v.product_id == p){
              $('#updates_'+v.id).prop('disabled',true);
              $('#updates_'+v.id).parent('.product-quantity-box').find('.product-plus').click(function(){
                  $(this).css('pointer-events','none');
              });
            }
            $('#updates_'+v.id).on('keyup',function(){
              if(parseInt($(this).val()) > parseInt(limit)){
                $('#warn_'+v.id).remove();
                $('#updates_'+v.id).parent('.product-quantity-box').after("<p id='warn_"+v.id+"'>You've exceeded the limit allowed for the "+v.product_title+"</p>");
                checkout.prop('disabled', true);
                checkout.css('cursor', 'not-allowed');
                checkout.html('<span class="icon-lock"></span>Limit Exceeded');
              }else{
                $('#warn_'+v.id).remove();
                checkout.prop('disabled', false);
                checkout.css('cursor', 'auto');
              } 
            });
         });
      });
    }



	// 	popup on change varient
	jQuery(document).on('click', '.js-product_section .js-product-form .swatch-element', function(){
      
      var varientName = jQuery(this).data('value');
      var type = $(this).parents('.swatch').find('.option_title .swatch-type').text();
      console.log(varientName);
      console.log(type);
      if ( type == 'Color' || type == 'color' ) {
          var product_name = $(this).parents('.product_form').data('product');
          if(product_name.title.toLowerCase().indexOf('lights') > 0 ){
            var currentColorway = varientName+' - '+jQuery('.swatch-type-light input[name="option-1"]:checked').val();
          }else{
            var currentColorway = varientName;
          }
        console.log(currentColorway);
          $(this).parents('.swatch').find('.option_title .current-color').text( varientName );
            var carouselFlickity = $('.product_gallery').data('flickity');
            var carouselNavFlickity = $('.product_gallery_nav').data('flickity');      

            carouselImagesQuickView = (carouselImagesQuickView === 0 || typeof carouselImagesQuickView === 'undefined') ? $('.product_gallery').find('.flickity-slider').children() : carouselImagesQuickView;
            carouselNavImagesQuickView = (carouselNavImagesQuickView === 0 || typeof carouselNavImagesQuickView === 'undefined') ? $('.product_gallery_nav').find('.flickity-slider').children() : carouselNavImagesQuickView;
            
        	if(!carouselImagesQuickView) return;
        	carouselFlickity.remove($('*'))
            carouselNavFlickity.remove($('*'));
            
        	carouselFlickity.insert(carouselImagesQuickView.filter('[data-title="'+currentColorway+'"]'))
            carouselNavFlickity.insert(carouselNavImagesQuickView.filter('[data-title="'+currentColorway+'"]'));
            
        	carouselFlickity.select(0, true, true);
            carouselNavFlickity.select(0, true, true);
          
        } else if ( type == 'Size' || type == 'size' ) {
          	$(this).parents('.swatch').find('.option_title .current-size').text(varientName);
        } else if ( type == 'style' || type == 'Style' ) {
          $(this).parents('.swatch').find('.option_title .current-style').text(varientName);
        } else if ( type == 'light' || type == 'Light' ) {
          var currentColorway = jQuery('.js-quick-shop .swatch-type-color input[name="option-0"]:checked').val()+' - '+varientName;
        console.log(currentColorway);
          $(this).parents('.swatch').find('.option_title .current-location').text(varientName);
          var carouselFlickity = $('.product_gallery').data('flickity');
            var carouselNavFlickity = $('.product_gallery_nav').data('flickity');      

            carouselImagesQuickView = (carouselImagesQuickView === 0 || typeof carouselImagesQuickView === 'undefined') ? $('.product_gallery').find('.flickity-slider').children() : carouselImagesQuickView;
            carouselNavImagesQuickView = (carouselNavImagesQuickView === 0 || typeof carouselNavImagesQuickView === 'undefined') ? $('.product_gallery_nav').find('.flickity-slider').children() : carouselNavImagesQuickView;
            
        	if(!carouselImagesQuickView) return;
        	carouselFlickity.remove($('*'))
            carouselNavFlickity.remove($('*'));
            
        	carouselFlickity.insert(carouselImagesQuickView.filter('[data-title="'+currentColorway+'"]'))
            carouselNavFlickity.insert(carouselNavImagesQuickView.filter('[data-title="'+currentColorway+'"]'));
            
        	carouselFlickity.select(0, true, true);
            carouselNavFlickity.select(0, true, true);
        }
	});


	// 	popup on open select first varients
    function updateVarientNames( varient_color ){
      	jQuery('.js-product-form .swatch').each( function( i , v ) {
          	var type = jQuery(v).find('.option_title .swatch-type').text();
          	if ( type == 'Color' || type == 'color' ) {
              	$(v).find('label[data-variant-name="'+varient_color+'"]').click();
              	jQuery(v).find('.option_title .current-color').text( varient_color );
            } else if ( type == 'Size' || type == 'size' ) {
              var varient_name = jQuery(v).find('.swatch-element').first().data('value');
              jQuery(v).find('.option_title .current-size').text( varient_name );
            } else if ( type == 'style' || type == 'Style' ) {
              var varient_name = jQuery(v).find('.swatch-element').first().data('value');
              jQuery(v).find('.option_title .current-style').text( varient_name );
            } else if ( type == 'light' || type == 'Light' ) {
              var varient_name = jQuery(v).find('.swatch-element').first().data('value');
              jQuery(v).find('.option_title .current-location').text( varient_name );
            }
        });
    }


    // delete simmilar elements with same classes
    function deleteSimmilarOuickViewElements() {
      	var products = [];
      	jQuery('.product-wrap').each(function( i , v ) {
          	var product_id = $(v).data('mainproductid');
          	if( jQuery.inArray( product_id , products) !== -1 ) {
              	$(v).find('.thumbnail-overlay').find('.js-quickshop-forms--' + product_id ).remove();
            } else {
            	products.push( product_id );
            }
         });
    }

console.log(user_loc);